import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TimestampService {
  public readonly updated = new EventEmitter<void>();
  private timeout?: number;

  public updateTime(): void {
    window.clearTimeout(this.timeout);
    this.timeout = window.setTimeout(() => {
      this.updated.emit();
    }, 1000);
  }
}
